var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mary Roebling") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask__ring",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 180,
    fill: "#FFFFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask__ring)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90v45H0z",
    fill: "#0db2ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45h90v45H0z",
    fill: "#f5dd7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 45a38 38 0 00-76 0h76z",
    fill: "#f5dd7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 45a38 38 0 01-76 0h76z",
    fill: "#fc8d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 45a32 32 0 10-64 0h64z",
    fill: "#fc8d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 45a32 32 0 11-64 0h64z",
    fill: "#fc694d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 45a26 26 0 00-52 0h52z",
    fill: "#fc694d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 45a26 26 0 01-52 0h52z",
    fill: "#0db2ac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 23,
    fill: "#faba32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/defaultAvatar.165b4d736487465bab5d5c79a2f46a3d.svg";
export { ForwardRef as ReactComponent };